import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable()
export class AWISLinkInterceptor implements HttpInterceptor {

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const awisLink = localStorage.getItem('awislink') ?? environment.AWISLink ?? '';
    if (awisLink) {
      request = request.clone({
        setHeaders: {
          AwisLink: awisLink,
        },
      });
    }
    return next.handle(request);
  }
}
